// extracted by mini-css-extract-plugin
export default {"invoiceRequestSpin":"styles_invoiceRequestSpin__6mSZL"};